const common = {
  // Navigation
  "nav.home": "Strona Główna",
  "nav.categories": "Kategorie",
  "nav.articles": "Artykuły",
  "nav.about": "O Nas",
  "nav.contact": "Kontakt",

  // Hero
  "hero.title.line1": "Kakobuy Spreadsheet",
  "hero.title.line2": "Najlepsze Finds i Listy",
  "hero.title.line3": "Produktów w Polsce",
  "hero.subtitle": "Odkrywaj najlepsze produkty, aktualne listy zakupowe oraz sprawdzone arkusze Kakobuy. Znajdź sneakersy, streetwear, elektronikę i wyjątkowe okazje szybciej niż kiedykolwiek.",
  "hero.cta.primary": "Kakobuy Sheet",
  "hero.cta.secondary": "Buy It Now",
  "hero.dropdown.placeholder": "Wybierz kategorię",

  // Stats
  "stats.categories": "Kategorii",
  "stats.products": "Produktów",
  "stats.updated": "Aktualizacja",
  "stats.users": "Użytkowników",
  "stats.label": "Kakobuy Spreadsheet w liczbach",

  // Categories
  "categories.title": "Kategorie Produktów",
  "categories.subtitle": "Przeglądaj nasze starannie wyselekcjonowane kategorie i znajdź dokładnie to, czego szukasz",
  "categories.view_all": "Zobacz wszystkie",

  // About / What is Kakobuy
  "about.title": "Czym jest Kakobuy Spreadsheet?",
  "about.desc1": "Kakobuy Spreadsheet to kompleksowe narzędzie do organizacji i odkrywania produktów. Zamiast przeszukiwać setki stron, otrzymujesz starannie posegregowane listy najlepszych znalezisk — od sneakersów po elektronikę.",
  "about.desc2": "Nasz arkusz jest regularnie aktualizowany przez społeczność doświadczonych shopperów, dzięki czemu zawsze masz dostęp do najświeższych okazji i sprawdzonych linków produktowych.",
  "about.benefit1": "Oszczędność czasu",
  "about.benefit2": "Sprawdzone produkty",
  "about.benefit3": "Regularne aktualizacje",
  "about.benefit4": "Wsparcie społeczności",

  // CTA Section
  "cta.title.line1": "Gotowy na zakupy?",
  "cta.title.line2": "Sprawdź Kakobuy Sheet",
  "cta.desc": "Uzyskaj dostęp do pełnej bazy produktów, porównaj ceny i znajdź najlepsze okazje. Wszystko w jednym miejscu, zawsze aktualne.",
  "cta.button": "Kakobuy Sheet",

  // Article Section
  "article.label": "Artykuły i poradniki",
  "article.title": "Kakobuy Spreadsheet —",
  "article.title2": "Kompletny przewodnik",
  "article.excerpt": "Dowiedz się, jak efektywnie korzystać z arkuszy Kakobuy, poznaj najlepsze strategie wyszukiwania produktów i odkryj sekrety doświadczonych shopperów. Nasz przewodnik pomoże Ci zaoszczędzić czas i pieniądze.",
  "article.author": "Zespół Redakcyjny Kakobuy Finds",
  "article.read_more": "Czytaj więcej",

  // Products Section
  "products.title": "Popularne Znaleziska",
  "products.subtitle": "Najczęściej wybierane produkty z naszego arkusza",

  // Newsletter
  "newsletter.title": "Bądź na bieżąco",
  "newsletter.subtitle": "Zapisz się do newslettera i otrzymuj najnowsze finds prosto na swoją skrzynkę",
  "newsletter.placeholder": "Twój adres email",
  "newsletter.button": "Zapisz się",
  "newsletter.success": "Dziękujemy za zapisanie się!",
  "newsletter.error": "Wystąpił błąd. Spróbuj ponownie.",

  // Footer
  "footer.tagline": "Największa baza finds i arkuszów zakupowych w Polsce",
  "footer.copyright": "© 2026 KakobuyFinds. Wszystkie prawa zastrzeżone.",
  "footer.privacy": "Polityka prywatności",
  "footer.terms": "Regulamin",
  "footer.contact": "Kontakt",

  // Categories list
  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy / Swetry",
  "cat.tshirts": "T-Shirty",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie / Szorty",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna",
  "cat.jersey": "Koszulki sportowe",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne",

  // SEO
  "seo.home.title": "Kakobuy Spreadsheet Polska – Największa Baza Finds, Linków i List Produktów",
  "seo.home.desc": "Kakobuy Spreadsheet Polska: odkrywaj najlepsze produkty, aktualne listy zakupowe oraz sprawdzone arkusze Kakobuy. Sneakersy, streetwear, elektronika i wyjątkowe okazje w jednym miejscu.",
  "seo.home.keywords": "Kakobuy Spreadsheet, Kakobuy Finds, arkusz zakupowy, lista produktów, spreadsheet shopping, Polska",
};

export default common;